
import { call, put, takeEvery } from "redux-saga/effects"

import { GET_INVOICES, UPDATE_INVOICE_STATUS } from "./actionTypes"
import {
    getInvoicesSuccess,
    getInvoicesFail,
    updateInvoiceStatusSuccess,
    updateInvoiceStatusFail
} from "./actions"
import { getAdminInvoices, updateInvoiceStatus } from "../../helpers/fakebackend_helper"

function* fetchInvoices() {
    try {
        const response = yield call(getAdminInvoices)
        yield put(getInvoicesSuccess(response))
    } catch (error) {
        yield put(getInvoicesFail(error))
    }
}

function* onUpdateInvoiceStatus({ payload: { invoiceId, status } }) {
    try {
        const response = yield call(updateInvoiceStatus, invoiceId, status)
        yield put(updateInvoiceStatusSuccess(response))
    } catch (error) {
        yield put(updateInvoiceStatusFail(error))
    }
}

function* invoicesAdminSaga() {
    yield takeEvery(GET_INVOICES, fetchInvoices)
    yield takeEvery(UPDATE_INVOICE_STATUS, onUpdateInvoiceStatus)
}

export default invoicesAdminSaga
